import { useEffect, useState } from "react";
import TableHeader from "../Components/TableHeader";
import "../Stylesheets/Users/Users.css";
import core from "../core";
import axios from "axios";
import { CheckCircleFill, PersonAdd, ThreeDotsVertical, XCircleFill } from "react-bootstrap-icons";
import TableFoot from "../Components/TableFoot";
import TableLoader from "../Components/TableLoader";
import AddNewUser from "../Components/AddNewUser";
import OutsideClickHandler from "react-outside-click-handler";
import DialogModal from "../Components/DialogModal";
import ChangePasswordModal from "../Components/ChangePasswordModal";
import { Modal } from "react-bootstrap";

const Users = ({setNotification}) => {
    const query = core.useQuery();
    const [filter, setFilter] = useState({
        page: query.page ? query.page : 1, limit: query.limit ? query.limit : 10, keyword: query.keyword ? query.keyword : "", 
        sort_by: query.sort_by ? query.sort_by : "", sort_order: query.sort_order ? query.sort_order : "DESC", eligible_to_bid: query.eligible_to_bid ? query.eligible_to_bid : "", 
        blocked: query.blocked ? query.blocked : "", admin_id: query.admin_id ? query.admin_id : "", active: query.active ? query.active : "", inactive_users: query.inactive_users ? query.inactive_users : ""
    });
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [sortBy, setSortBy] = useState([]);
    const checkboxes = [{name: "eligible_to_bid", value: "Eligible To Bid"}, {name: "inactive_users", value: "Inactive Users"}, {name: "blocked", value: "Blocked"}, {name: "active", value: "Is Active"}];
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [total,setTotal] = useState(0);
    const [modals, setModals] = useState({createUser: false, deleteUser: false});
    const [formData, setFormData] = useState({
        username: "", password: "", email: "", copart_accounts: [], iaai_accounts: [], copart_status: false, iaai_status: false, limited_amount: "0", purchase_limit: "0",
        is_active: true, name: "", surname: "", phone: "", role: "", admin: ""
    });
    const [active, setActive] = useState("");
    const [action, setAction] = useState("add");
    const [dialog, setDialog] = useState({show: false, title: "", text: "", id: "", loader: false});
    const [reRender, setReRender] = useState(0);
    const [changePassword, setChangePassword] = useState({show: false, id: "", password: "", repeat_password: "", loader: false});
    const [exportLoad, setExportLoad] = useState(false);
    const [exportLimit, setExportLimit] = useState({modal: false, limit: "10"});
    const [changeBuyersForm, setChangeBuyersForm] = useState({current_buyer: "", new_buyer: "", account: "copart", show: false});
    const [load, setLoad] = useState(false);

    const handlers = {
        openEditUserModal(user){
            setActive("");
            const copartIsNull = user.copart_accounts == null;
            const copartIsUndefined = typeof user.copart_accounts == "undefined";
            const iaaiIsNull = user.iaai_accounts == null;
            const iaaiIsUndefined = typeof user.iaai_accounts == "undefined";
            const copartAccountsList = (copartIsNull || copartIsUndefined) ? [] : (typeof user.copart_accounts == "string" ? JSON.parse(user.copart_accounts) : user.copart_accounts);
            const iaaiAccountsList = (iaaiIsNull || iaaiIsUndefined) ? [] : (typeof user.iaai_accounts == "string" ? JSON.parse(user.iaai_accounts) : user.iaai_accounts);
            const ca = copartAccountsList.map((acc) => ({label: acc, value: acc}));
            const ia = iaaiAccountsList.map((acc) => ({label: acc, value: acc}));
            setFormData({
                username: user.username, email: user.email, copart_accounts: ca, iaai_accounts: ia, copart_status: user.copart_status, iaai_status: user.iaai_status, limited_amount: user.limited_amount, purchase_limit: user.purchase_limit,
                is_active: user.is_active, name: user.name, surname: user.surname, phone: user.phone, role: user.role, admin: user.admin_id, id: user.id
            });
            setAction("edit");
            setTimeout(() => {
                setModals((prev) => ({...prev, createUser: true}));
            }, 500)
        }, 
        addNewHandler(){
            setFormData({
                username: "", password: "", email: "", copart_accounts: [], iaai_accounts: [], copart_status: false, iaai_status: false, limited_amount: "0", purchase_limit: "0",
                is_active: true, name: "", surname: "", phone: "", role: "", admin: ""
            });
            setAction("add")
        },
        openRemoveUserModal(user){
            setDialog({show: true, title: "Remove User", text: "Do you want to remove this user?", id: user.id});
            setActive("");
        },
        deleteUser(){
            setDialog((prev) => ({...prev, loader: true}));
            axios.delete(`/api/extension/v1/users/${dialog.id}`)
                .then((res) => {
                    const data = res.data;
                    setNotification({show: true, type: "success", text: data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setReRender((prev) => prev + 1);
                    setDialog({show: false, title: "", text: "", id: "", loader: false})
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setDialog({show: false, title: "", text: "", id: "", loader: false})
                })
        },
        openChangePasswordModal(user){
            setChangePassword({show: true, id: user.id, password: "", repeat_password: ""})
        },
        changePasswordHandler(e){
            e.preventDefault();
            if(changePassword.password != changePassword.repeat_password){
                setNotification({show: true, type: "error", text: "Passwords don't match"});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            }else{
                setChangePassword((prev) => ({...prev, loader: true}))
                axios.put(`/api/extension/v1/users/${changePassword.id}/change-password`, changePassword)
                    .then((res) => {
                        setNotification({show: true, type: "success", text: res.data.message.en});
                        setTimeout(() => {
                            setNotification({show: false, title: "", text: ""});
                        }, 3000);
                        setChangePassword({show: false, id: "", password: "", repeat_password: "", loader: false});
                    })
                    .catch((err) => {
                        setNotification({show: true, type: "error", text: err.response.data.message.en});
                        setTimeout(() => {
                            setNotification({show: false, title: "", text: ""});
                        }, 3000);
                        setChangePassword((prev) => ({...prev, loader: false}))
                    })
            }
        },
        exportUsers(){
            setExportLoad(true);
            axios.get(`/api/extension/v1/export/users?page=${filter.page}&limit=${exportLimit.limit}&keyword=${filter.keyword}&sort_by=${filter.sort_by}&sort_order=${filter.sort_order}&eligible_to_bid=${filter.eligible_to_bid}&blocked=${filter.blocked}&admin_id=${filter.admin_id}&active=${filter.active}`)
                .then((res) => {
                    const host = window.location.hostname.replace('.ge/', ".ge");
                    const url = `${res.data.url}`;
                    window.open(url, "_blank")
                    setExportLoad(false);
                    setExportLimit((prev) => ({...prev, modal: false}))
                })
                .catch((err) => {
                    setExportLoad(false);
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                })
        },
        changeBuyers(e){
            e.preventDefault();
            setLoad(true);
            axios.put('/api/extension/v1/change-buyer', {current_buyer: changeBuyersForm.current_buyer, new_buyer: changeBuyersForm.new_buyer, account: changeBuyersForm.account, selectedUsers: selectedUsers, bySelected: true})
                .then((res) => {
                    setLoad(false);
                    setNotification({show: true, type: "success", text: res.data.message.en});
                    setChangeBuyersForm({current_buyer: "", new_buyer: "", account: "copart", show: false});
                    setReRender((prev) => prev + 1);
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                })
                .catch((err) => {
                    setLoad(false);
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                })
        }
    }

    useEffect(() => {
        axios('/api/extension/v1/options?name=user-sort-by')
            .then((res) => {
                const data = res.data.data;
                setSortBy(typeof data == "string" ? JSON.parse(data) : data);
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
    }, [])

    useEffect(() => {
        setLoading(true);
        setUsers([]);
        axios(`/api/extension/v1/users?page=${filter.page}&limit=${filter.limit}&keyword=${filter.keyword}&sort_by=${filter.sort_by}&sort_order=${filter.sort_order}&inactive_users=${filter.inactive_users}&eligible_to_bid=${filter.eligible_to_bid}&blocked=${filter.blocked}&admin_id=${filter.admin_id}&active=${filter.active}`)
            .then((res) => {
                const data = res.data.data;
                setUsers(data);
                const count = res.data.total;
                const pageCount = count <= filter.limit ? 1 : (count % filter.limit == 0 ? count / filter.limit : parseInt(count / filter.limit) + 1);
                setTotal(pageCount);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false)
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
    }, [filter, reRender])

    return(
        <div className="page-content-container">
            <h2 className="page-title">Users</h2>
            <TableHeader addNewHandler={handlers.addNewHandler} exportHandler={() => setExportLimit((prev) => ({...prev, modal: true}))} exportLoad={exportLoad} setExportLoad={setExportLoad} setNotification={setNotification} AddNewButtonIcon={PersonAdd} setModals={setModals} filter={filter} sortBy={sortBy} exportButton={true} checkboxes={checkboxes} setFilter={setFilter} />
            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <button className="export-button" style={{marginTop: "10px"}} onClick={() => setChangeBuyersForm({current_buyer: "", new_buyer: "", account: "copart", show: true})}>
                    Change Buyers
                </button>
            </div>
            <table className="responsive-d-table">
                <thead>
                    <tr>
                        <th style={{width: "33px"}}><input style={{cursor: "pointer"}} type="checkbox"  onChange={(e) => {
                            if(e.target.checked){

                            }else{

                            }
                        }} /></th>
                        <th>Username</th>
                        <th>Email</th>
                        <th>Copart</th>
                        <th>Copart Accounts</th>
                        <th>IAAI</th>
                        <th>IAAI Accounts</th>
                        <th>Last Login</th>
                        <th>Last Bid</th>
                        <th>Eligible To Bid</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (!loading && users.length > 0) && users.map((user, id) => {
                            return <tr key={user.id} className={(id + 2) % 2 == 0 ? "even-row" : "odd-row"}>
                                <td><input type="checkbox" defaultChecked={selectedUsers.includes(user.id)} onChange={() => {
                                    setSelectedUsers(prev => {
                                        if (prev.includes(user.id)) {
                                            return prev.filter(id => id !== user.id);
                                        } else {
                                            return [...prev, user.id];
                                        }
                                    });
                                }}/></td>
                                <td>{user.username}</td>
                                <td>{user.email}</td>
                                <td>{user.copart_status ? <CheckCircleFill style={{color: "green", fontSize: "20px"}} /> : <XCircleFill style={{color: "red", fontSize: "20px"}} />}</td>
                                <td title={typeof user.copart_accounts == "string" ? JSON.parse(user.copart_accounts).join(", ") : (user.copart_accounts == "null" || user.copart_accounts == null) ? "" : user.copart_accounts.join(", ")}>{typeof user.copart_accounts == "string" ? JSON.parse(user.copart_accounts).join(", ").slice(0, 20) : (user.copart_accounts == "null" || user.copart_accounts == null) ? "" : user.copart_accounts.join(", ").slice(0, 20)}</td>
                                <td>{user.iaai_status ? <CheckCircleFill style={{color: "green", fontSize: "20px"}}/> : <XCircleFill style={{color: "red", fontSize: "20px"}} />}</td>
                                <td title={typeof user.iaai_accounts == "string" ? JSON.parse(user.iaai_accounts).join(", ") : (user.iaai_accounts == "null" || user.iaai_accounts == null) ? "" : user.iaai_accounts.join(", ")}>{typeof user.iaai_accounts == "string" ? JSON.parse(user.iaai_accounts).join(", ").slice(0, 20) : (user.iaai_accounts == "null" || user.iaai_accounts == null) ? "" : user.iaai_accounts.join(", ").slice(0, 20)}</td>
                                <td>{user.last_login_date ? core.formdatDate(new Date(user.last_login_date), 'yyyy-mm-dd hr:min') : "Not Defined"}</td>
                                <td>{user.last_bid_date ? core.formdatDate(new Date(user.last_bid_date), 'yyyy-mm-dd hr:min') : "Not Defined"}</td>
                                <td>{user.eligible_to_bid ? <CheckCircleFill style={{color: "green", fontSize: "20px"}} /> : <XCircleFill style={{color: "red", fontSize: "20px"}}/>}</td>
                                <td>
                                    <ThreeDotsVertical onClick={() => setActive(user.id)} style={{color: "white", fontSize: "18px", cursor: "pointer"}} />
                                    {active == user.id && <OutsideClickHandler onOutsideClick={() => setActive("")}>
                                        <div className="table-actions-box">
                                            <ul>
                                                <li onClick={() => handlers.openEditUserModal(user)}>Edit</li>
                                                <li onClick={() => handlers.openChangePasswordModal(user)}>Change password</li>
                                                <li onClick={() => handlers.openRemoveUserModal(user)}>Delete</li>
                                            </ul>
                                        </div>    
                                    </OutsideClickHandler>}
                                </td>
                            </tr>
                        })
                    }
                    {
                        (!loading && users.length == 0) && <tr style={{background: "#494646ff"}}>
                            <td colSpan={11}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>
                    }
                    {
                        loading && <TableLoader colspan={11}/>
                    }
                </tbody>
            </table>
            <TableFoot filter={filter} setFilter={setFilter} count={total} />
            <AddNewUser setReRender={setReRender} setNotification={setNotification} action={action} show={modals.createUser} setShow={setModals} formData={formData} setFormData={setFormData}/>
            <DialogModal show={dialog.show} setShow={setDialog} title={dialog.title} text={dialog.text} onSubmit={handlers.deleteUser} loader={dialog.loader} />
            <ChangePasswordModal changePassword={changePassword} setChangePassword={setChangePassword} onSubmit={handlers.changePasswordHandler}/>
            <Modal show={exportLimit.modal} onHide={() => setExportLimit((prev) => ({...prev, modal: false}))}>
                <Modal.Header closeButton><h5 style={{color: "#afb9cf"}}>Export Data Limit</h5></Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="form-group" style={{padding: "0"}}>
                                <label>Select Limit</label>
                                <select value={exportLimit.limit} onChange={(e) => setExportLimit((prev) => ({...prev, limit: e.target.value}))} className="form-control">
                                    <option>Select Limit</option>
                                    <option value={50000}>All</option>
                                    <option value={10}>10</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={200}>200</option>
                                </select>
                            </div>
                            <button disabled={exportLoad} style={{marginLeft: "0", marginTop: "20px"}} onClick={handlers.exportUsers} className="export-button">{exportLoad ? <div className="button-loader"></div> : "Export"}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={changeBuyersForm.show} onHide={() => setChangeBuyersForm((prev) => ({...prev, show: false}))} centered>
                <Modal.Header closeButton>
                    <Modal.Title style={{color: "white"}}>Change Buyer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="change-buyers-form" onSubmit={handlers.changeBuyers}>
                        <div className="form-group mt-3">
                            <label>Current Buyer</label>
                            <input required className="form-control" value={changeBuyersForm.current_buyer} onChange={(e) => setChangeBuyersForm((prev) => ({...prev, current_buyer: e.target.value}))} placeholder="Current Buyer" />
                        </div>
                        <div className="form-group  mt-3">
                            <label>New Buyer</label>
                            <input className="form-control" value={changeBuyersForm.new_buyer} onChange={(e) => setChangeBuyersForm((prev) => ({...prev, new_buyer: e.target.value}))} placeholder="New Buyer" />
                        </div>
                         <div className="form-group  mt-3">
                            <label>Account</label>
                            <select className="form-control" value={changeBuyersForm.account} onChange={(e) => setChangeBuyersForm((prev) => ({...prev, account: e.target.value}))}>
                                <option value="copart">Copart
                                </option>
                                <option value="iaai">IAAI</option>
                            </select>
                        </div>
                        <button disabled={load} type="submit" className="btn btn-primary mt-5" style={{width: "100%"}} onClick={() => {
                            // Handle change buyer logic
                        }}>{load ? "Changing..." : "Change Buyer"}</button>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Users